(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8227],{

/***/ 78227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content058": function() { return /* binding */ Content058; },
  "default": function() { return /* binding */ Content058_Content058; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/widgets/index.js + 3 modules
var widgets = __webpack_require__(68642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/PageData/index.js + 3 modules
var PageData = __webpack_require__(65202);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./src/components/widgets/content/Content058/Content058.module.scss
var Content058_module = __webpack_require__(99106);
var Content058_module_default = /*#__PURE__*/__webpack_require__.n(Content058_module);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/content/Content058/Item/Item.module.scss
var Item_module = __webpack_require__(70580);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content058/Item/Item.jsx





var DEFAULT_VISIBLE_LETTERS = 150;
var Item = function(param) {
    var item = param.item;
    var truncatedDescription = (0,react.useMemo)(function() {
        return (0,utils/* truncateText */.aF)(item.description, DEFAULT_VISIBLE_LETTERS);
    }, [
        item.description
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
        directory: "projects",
        slug: item === null || item === void 0 ? void 0 : item.slug,
        className: (Item_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Item_module_default()).block,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                    image: item.previewImage,
                    className: (Item_module_default()).image
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Item_module_default()).title,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                            color: "light",
                            appearance: "bold",
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Item_module_default()).arrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: (Item_module_default()).icon,
                                name: "arrow_right"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                    color: "light",
                    className: (Item_module_default()).description,
                    children: truncatedDescription
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content058/Item/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content058/Content058.jsx










var Content058 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var template = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    var prevRef = react.useRef(null);
    var nextRef = react.useRef(null);
    var instanceId = (0,widgets/* buildWidgetInstanceId */.G1)("058", payload.id);
    var projects = (0,PageData/* useCollectedData */.M)(instanceId, [
        {
            name: "projects",
            defaultValue: []
        }, 
    ]).projects;
    if (projects.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Content058_module_default()).wrapper, (Content058_module_default())[template]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (Content058_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Content058_module_default()).top,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (Content058_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RenderIf */.$b, {
                            viewMode: ViewMode/* VIEW_MODES.DESKTOP */.nY.DESKTOP,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Content058_module_default())["slider-navigation"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: prevRef,
                                        className: classnames_default()((Content058_module_default()).navigation, (Content058_module_default())["navigation-prev"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content058_module_default()).icon,
                                            name: "arrow_slider_prev"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        ref: nextRef,
                                        className: classnames_default()((Content058_module_default()).navigation, (Content058_module_default())["navigation-next"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                            className: (Content058_module_default()).icon,
                                            name: "arrow_slider_next"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Content058_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                    prevRef: prevRef,
                    nextRef: nextRef,
                    watchOverflow: true,
                    slidesPerView: "auto",
                    spaceBetween: 4,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 30,
                    children: projects === null || projects === void 0 ? void 0 : projects.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (Content058_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                className: (Content058_module_default()).item,
                                item: item
                            })
                        }, item.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Content058_Content058 = (Content058);


/***/ }),

/***/ 99106:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content058_wrapper__C0iWq","grey":"Content058_grey__Tbu9o","light":"Content058_light__L2BPv","top":"Content058_top__OwxsJ","title":"Content058_title__TGtMK","slider":"Content058_slider__D2LG5","slider-navigation":"Content058_slider-navigation__lNKgo","position":"Content058_position__sUehf","navigation":"Content058_navigation__cqxD6","navigation-prev":"Content058_navigation-prev__Mz4Rs","navigation-next":"Content058_navigation-next__cwbfz","slide":"Content058_slide__kKBL_"};

/***/ }),

/***/ 70580:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper___8yod","title":"Item_title__GURQn","block":"Item_block__hwfxa","description":"Item_description__2Detn","image":"Item_image__HN0Uf","arrow":"Item_arrow__XWW6y","button":"Item_button__8BVtk"};

/***/ })

}]);